<template>
  <div class="password-find" :class="className">
    <el-image
      style="width: 32px; height: 32px"
      src="https://static.zc0901.com/dci-miniapp/form-close-icon.png"
      class="form-close"
      @click="closeForm"
      v-if="!type"
    ></el-image>
    <aside class="password-find_top">
      <p class="h0 bold text-center">{{type?'找回密码':'修改登录密码'}}</p>
    </aside>

    <div class="password-find_tab">
      <div class="modifyPassword" v-if="showTip">
        <img src="https://static.zc0901.com/dci-miniapp/success-pc-icon.png" />
        <i class="text-red h5 prl1">修改密码成功</i>
        <img
          src="https://static.zc0901.com/dci-miniapp/close-password-icon.png"
          class="tipLeft"
          @click="closeTip"
        />
      </div>
      <el-form :rules="loginRules" ref="forgetForm" :model="forgetForm" label-width="0">
        <el-form-item prop="mobile">
          <el-input
            size="medium"
            @keyup.enter.native="handleLogin"
            v-model="forgetForm.mobile"
            auto-complete="off"
            placeholder="手机号"
            maxlength="11"
            @input="ckickFlag=false"
          ></el-input>
        </el-form-item>
        <InputSmsCode
          :phone="forgetForm.mobile"
          :value="forgetForm.smsCode"
          @getValue="getValue"
          prop="captcha"
          :ckickFlag="ckickFlag"
        ></InputSmsCode>
        <el-form-item prop="password">
          <el-input
            size="medium"
            @keyup.enter.native="handleLogin"
            :type="passwordType"
            v-model.trim="forgetForm.password"
            auto-complete="off"
            placeholder="新密码（6位数字）"
            maxlength="6"
          ></el-input>
        </el-form-item>
        <el-form-item prop="confirmPassword">
          <el-input
            size="medium"
            @keyup.enter.native="handleLogin"
            :type="passwordType"
            v-model.trim="forgetForm.confirmPassword"
            auto-complete="off"
            placeholder="再次输入新密码"
            maxlength="6"
          ></el-input>
        </el-form-item>
        <el-form-item class="mt6">
          <el-button class="btn-login" type="primary" @click.native.prevent="handleLogin()">保存</el-button>
        </el-form-item>
        <p class="text-gray text-center h6">新密码应不少于 6 位，且不可与之前设置过的密码重复</p>
      </el-form>
    </div>
  </div>
</template>
<script>
import { phoneNo } from "@/common/regex";
import InputSmsCode from "./inputSmsCode";
let timer = null;
export default {
  props: ["type", "className"],
  components: { InputSmsCode },
  data() {
    const validatetaskMobile = async (rule, value, callback) => {
      // if ((this.ckickFlag || !this.phone) && this.phone !== value) {
      if (this.phone !== value || (this.ckickFlag && !this.phone)) {
        //正确的手机号并且不能与上次输入的相同
        await this.checkPhone();
      }
      if (this.errorTip) {
        callback(new Error("该手机号尚未注册"));
      }
      callback();
    };
    let validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else {
        if (this.forgetForm.confirmPassword !== "") {
          this.$refs.forgetForm.validateField("confirmPassword");
        }
        callback();
      }
    };
    let validateConfirmPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.forgetForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      passwordType: "password",
      ckickFlag: true,
      errorTip: "",
      phone: "",
      showTip: false,
      forgetForm: {
        mobile: "",
        captcha: "",
        password: "",
        confirmPassword: ""
      },
      loginRules: {
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: phoneNo,
            message: "请输入正确的手机号码",
            trigger: "blur"
          },
          { validator: validatetaskMobile, trigger: "blur" }
        ],
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, max: 6, message: "请输入六位数密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" }
        ],
        confirmPassword: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          { min: 6, max: 6, message: "请输入六位数密码", trigger: "blur" },
          { validator: validateConfirmPass, trigger: "blur" }
        ]
      }
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    //获取验证码
    getValue(value) {
      this.forgetForm.captcha = value;
    },
    //关闭弹窗
    closeForm() {
      this.$emit("closePass");
    },
    //校验手机号是否注册过
    async checkPhone() {
      let params = {
        mobile: this.forgetForm.mobile
      };
      this.phone = this.forgetForm.mobile;
      const res = await this.$store.dispatch("user/CHECKMOBILE", params);
      // if (res.code === 200 && res.data.status) {
      if (res.code === 200 && res.data.register) {
        this.ckickFlag = true;
        this.errorTip = "";
        //注册过
      // } else if (res.code === 200 && !res.data.register) {
      } else if (res.code === 200 && !res.data.register) {
        //未注册过
        this.errorTip = "该手机号尚未注册";
        this.ckickFlag = false;
      }
    },
    closeTip() {
      this.showTip = false;
      clearInterval(timer);
    },
    //提交
    handleLogin() {
      this.$refs.forgetForm.validate(async valid => {
        if (valid) {
          let params = {
            ...this.forgetForm
          };                
          const res = await this.$store.dispatch("user/FINDPASSWORD", params);
          if (res.code === 200 && res.data) {
            this.loginFlag = true;
            this.showTip = true;
            let self = this;
            let num = 3;
            timer = setInterval(function() {
              num--;
              if (num == 0) {
                clearInterval(timer);
                self.$router.push("/login");
              }
            }, 1000);
            // this.$message.success("密码修改成功").onClose = () => {
            //   self.$router.push("/login");
            // };
          }
        }
      });
    }
  }
};
</script>
<style scoped lang="scss">
.password-find {
  background: #fff;
  border-radius: 4px;
  -moz-border-radius: 4px;
  -webkit-border-radius: 4px;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  width: 384px;
  margin-right: 20%;
  height: 498px;
  position: relative;
  &_top {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    background-image: url("https://static.zc0901.com/dci-miniapp/password.png");
    background-size: cover;
    p {
      width: 100%;
    }
  }
  &_tab {
    padding: 0 32px;
  }
  .btn-login {
    width: 100%;
  }
  .form-close {
    position: absolute;
    top: 12px;
    right: 12px;
    cursor: pointer;
  }
  .modifyPassword {
    position:absolute;
    top:0;
    right:0;
    left:0;
    display: flex;
    align-items: center;
    width: 320px;
    height: 34px;
    margin: 0 auto;
    padding: 0 8px;
    background: rgba(243, 233, 233, 1);
    border-radius: 2px;
    border: 1px solid rgba(139, 42, 42, 1);
    img {
      display: inline-block;
      width: 18px;
      height: 18px;
    }
    .tipLeft {
      margin-left: auto;
      cursor: pointer;
    }
  }
}
.password-find_tab{
  position:relative;
  padding-top:34px;
}
</style>
<style lang="scss">
.password-find_tab {
  input {
    border: none;
    padding: 0;
    border-radius: 0;
    border-bottom: 1px solid #e5e5e5;
  }
}
</style>
